export default __webpack_public_path__ + "static/media/suitenupcias_1.ccb4ecb1.jpg";